module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentType, {
    tag: "a",
    attrs: {
      "active-class": _vm.activeClass,
      "disabled": _vm.disabled,
      "aria-disabled": _vm.disabled ? 'true' : 'false',
      "to": _vm.to,
      "exact": _vm.exact
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe11024e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/link.vue
// module id = 268
// module chunks = 0